import React from "react";
import { useState, useEffect, useCallback, useRef } from "react";
import ReactPaginate from "react-paginate";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import frame from "../../assets/svg/Frame.svg";
import clock from "../../assets/svg/clock.svg";
import org from "../../assets/svg/org.svg";
import proof from "../../assets/svg/Proof.svg";
import pov from "../../assets/svg/pov.svg";
import meet from "../../assets/svg/meet.svg";
import approval from "../../assets/svg/approval.svg";
import cf from "../../assets/svg/cf.svg";
import cus from "../../assets/svg/cus.svg";
import df from "../../assets/svg/df.svg";
import filt from "../../assets/svg/filt.svg";
import que from "../../assets/svg/que.svg";
import arrow from "../../assets/svg/arrow.svg";
import gtin from "../../assets/svg/gtin.svg";
import gtot from "../../assets/svg/gtot.svg";
import scheule from "../../assets/svg/scheule.svg";
import search from "../../assets/svg/search.svg";
import vector from "../../assets/svg/Vector.svg";
import vectorup from "../../assets/svg/Vector up.svg";
import qr from "../../assets/svg/qr.svg";
import lar from "../../assets/svg/lar.svg";
import rar from "../../assets/svg/rar.svg";
import p1 from "../../assets/svg/p1.svg";
import p2 from "../../assets/svg/p2.svg";
import dw from "../../assets/svg/dw.svg";
import pn from "../../assets/svg/pn.svg";
import bu from "../../assets/svg/bu.svg";
import lo from "../../assets/svg/lo.svg";
import ph from "../../assets/svg/ph.svg";
import mail from "../../assets/svg/mail.svg";
import mp from "../../assets/svg/mp.svg";
import ent from "../../assets/svg/ent.svg";
import TopBar from "../topbar/TopBar";
import { get } from "../../services/apiService";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../../components/courier/courierlist.css";
import { getDepartmentFilterApi, getLocationFilterApi } from "./courier-api";
import { Container, Row, Col, Toast, ToastContainer } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import CourierReceivedModal from "../modal-dialog/courier-received-modal";
import CheckListFailedAdminModal from "../modal-dialog/checklist-failed-admin-modal";
import { checkListFailsUpdateApi } from "../visitor/visitor-api";
import { useGlobal } from "../../GlobalContext.js";
import gate from "../../assets/svg/gate-details.svg";

const CourierList = () => {
   const { courierCurrentTab, setCourierCurrentTab} = useGlobal();

  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const isFirstRun = useRef(true);
  const styles = {
    pagination: {
      display: "flex",
      listStyle: "none",
      gap: "10px",
      justifyContent: "center",
      padding: "10px",
    },
    pageItem: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "30px",
      height: "30px",
      padding: "10px",
      border: "1px solid #ddd",
      cursor: "pointer",
      borderRadius: "100px",
      fontFamily: "Epilogue",
      fontSize: "12px",
      fontWeight: 500,
    },
    activePage: {
      backgroundColor: "#6929E2",
      color: "white",
      fontWeight: "bold",
    },
  };

  
    const [courierDetails,setCourierDetails] =useState({});
    const [selectedStatus, setSelectedStatus] = useState("");
    const [showUpdateCourierStatusModal, setShowUpdateCourierStatusModal] = useState(false);
    const [showChecklistFailedAdminModal, setChecklistFailedAdminModal] = useState(false);

  const [isVisible, setIsVisible] = useState(false);
  const [hoveredRow, setHoveredRow] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showInput, setShowInput] = useState(false);
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  //sorting
  const [sortByField, setSortByField] = useState("");
  const [sortBy, setSortBy] = useState("");

  //search
  const [term, setTerm] = useState("");

  const [showCustomColumPopup, setShowCustomColumPopup] = useState(false);
      const [listingColumns,setListingColumns] =useState([
        {"label": "S.No", "status": true, "value": "code"},
    {"label": "Person Name", "status": true, "value": "person_name"},
    {"label": "Gate", "status": true, "value": "gate"},
    {"label": "In time", "status": true, "value": "in_time"},
    {"label": "Received time", "status": true, "value": "received_time"},
    {"label": "Company name", "status": true, "value": "company_name"},
    {
      "label": "Company contact number",
      "status": true,
      "value": "company_contactnumber"
    },
    {"label": "Receiver name", "status": true, "value": "first_name"},
      ]);
  

  // Define button options
  const buttons = [
    { label: "Approved", value: "approved" },
    { label: "Checklist Failed", value: "checklist-failed" },
    { label: "Rejected", value: "rejected" },
    { label: "Completed", value: "completed" },
  ];

  // State for active button
  const [activeButton, setActiveButton] = useState(courierCurrentTab);
  const [approvedCount, setApprovedCount] = useState(0);
  const [checkListCount, setCheckListCount] = useState(0); 
  const [completedCount, setCompletedCount] = useState(0);
  const [rejectedCount, setRejectedCount] = useState(0);
  // Button click handler
  const handleButtonClick = (buttonValue) => {
    setActiveButton(buttonValue);
    setCourierCurrentTab(buttonValue)
    /* getListData(activeButton); */
     // Just update state
  };

  //Reset Filter
  const handleReset = () => {
    setLocation("");
    setDepartment("");
    setDateRange([null, null]);
    setGateInRange([null, null]);
    setGateOutRange([null, null]);
  };

  const handlePageClick = useCallback((event) => {
    const newOffset = (event.selected * itemsPerPage) % couriers.length;
    console.log(
      `User requested page number ${event.selected}, which is offset ${newOffset}`
    );
    setItemOffset(event.selected);
  }, []);

  //List
  const [list, setList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [itemOffset, setItemOffset] = useState(0);

  // location , department , status
  const [location, setLocation] = useState("");
  const [department, setDepartment] = useState("");

  //date range
  const [dateRange, setDateRange] = useState([null, null]);
  const [from_date, to_date] = dateRange;

  const formatDate = (date) => {
    if (!date) return "";
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const formattedFromDate = formatDate(from_date);
  const formattedToDate = formatDate(to_date);

  // State for Gate In date range
  const [gateInRange, setGateInRange] = useState([null, null]);
  const [from_gate_in, to_gate_in] = gateInRange;

  const formattedFromGateIn = formatDate(from_gate_in);
  const formattedToGateIn = formatDate(to_gate_in);

  // State for Gate Out date range
  const [gateOutRange, setGateOutRange] = useState([null, null]);
  const [from_gate_out, to_gate_out] = gateOutRange;

  const formattedFromGateOut = formatDate(from_gate_out);
  const formattedToGateOut = formatDate(to_gate_out);

  const [data, setData] = useState({
    gateInCount: 0,
    gateOutCount: 0,
    scheduleCount: 0,
    schedulePercentage: 0,
    gateInPercentage: 0,
    gateOutPercentage: 0,
  });

  //const response = await get(apiUrl + "visitors?limit="+itemsPerPage+"&skip="+itemOffset+"&from_gate_in="+from_gate_in+"&to_gate_in="+to_gate_in+"&from_gate_out="+from_gate_out+"&to_gate_out="+to_gate_out+"&department_id="+department+"&location_id="+location+"&fromCreatedDate="+from_date+"&toCreatedDate="+to_date+"&status="+status+"&type="+activeButton).then(async (response) => {

  const [couriers, setCouriers] = useState([]);
  const [loginID, setLoginID] = useState(0);
  const [locations, setLocations] = useState([]);

  const [departments, setDepartments] = useState([]);

   const [showSnackbar, setShowSnackbar] = useState(false);
        const [snackbarMessage, setSnackbarMessage] = useState("");
        const [snackbarStatus, setSnackbarStatus] = useState(false);
        const handleSnackbarShow = () => setShowSnackbar(true);
        const handleSnackbarClose = () => setShowSnackbar(false);

  useEffect(() => {

    getListData(term); // Keep current search value while sorting
  }, [itemOffset, itemsPerPage, activeButton, sortByField, sortBy,term]);

  //List Api
  const getListData = async (term) => {
    setCouriers([])
    try {
      const response = await get(
        apiUrl +
          "courier?limit=" +
          itemsPerPage +
          "&skip=" +
          (itemOffset) * itemsPerPage +
          "&type=" +
          activeButton +
          "" +
          "&search=" +
          encodeURIComponent(term) +
          "&sortByField=" +
          sortByField +
          "&sortBy=" +
          sortBy
      )
        .then(async (response) => {
          if (response.data.status === true) {
            setTotalCount(response.data.total_rec ?? 0);
            setPageCount(response.data.totalPages);
            //setCouriers(response.data);
            setLoginID(response.data.loginId??0);
            setCouriers(response.data.vehicles);
            console.log("Courier",response);
            
            console.log("page:",pageCount);

            setData({
              gateInCount: response.data.gateInCount,
              gateOutCount: response.data.gateOutCount,
              scheduleCount: response.data.scheduleCount,
              schedulePercentage: response.data.schedulePercentage,
              gateInPercentage: response.data.gateInPercentage,
              gateOutPercentage: response.data.gateOutPercentage,
            });
            setApprovedCount(response.data.approvedCount ?? 0);
            setCheckListCount(response.data.checkListFailedCount ?? 0);
            setCompletedCount(response.data.completedCount ?? 0);
            setRejectedCount(response.data.rejectedCount ?? 0); 

            
          }
        })
        .catch((error) => {
          if (error.response) {
            console.error("Error Status:", error.response.status);
            console.error("Error Data:", error.response.data);
            if (error.response.status === 400) {
            }
          }
        });
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  //filter list api
  const getFilterListData = async () => {
    try {
      const response = await get(
        apiUrl +
          "courier?" +
          "limit=" +
          itemsPerPage +
          "&skip=" +
          itemOffset +
          "&from_gate_in=" +
          formattedFromGateIn +
          "&to_gate_in=" +
          formattedToGateIn +
          "&from_gate_out=" +
          formattedFromGateOut +
          "&to_gate_out=" +
          formattedToGateOut +
          "&department_id=" +
          department +
          "&location_id=" +
          location +
          "&fromCreatedDate=" +
          formattedFromDate +
          "&toCreatedDate=" +
          formattedToDate +
          "&type=" +
          activeButton +
          "&search=" +
          encodeURIComponent(term) +
          "&sort_by_field=" +
          sortByField +
          "&sort_by=" +
          sortBy
      );

      if (response.data.status === true) {
        setTotalCount(response.data.total_rec ?? 0);
        setPageCount(response.data.totalPages);
        setCouriers(response.data.vehicles);
        console.log("hello",pageCount);

        setData({
          gateInCount: response.data.gateInCount,
          gateOutCount: response.data.gateOutCount,
          scheduleCount: response.data.scheduleCount,
          schedulePercentage: response.data.schedulePercentage,
          gateInPercentage: response.data.gateInPercentage,
          gateOutPercentage: response.data.gateOutPercentage,
        });
        setApprovedCount(response.data.approvedCount ?? 0);
        setCheckListCount(response.data.checkListFailedCount ?? 0);
        setCompletedCount(response.data.completedCount ?? 0);
        setRejectedCount(response.data.rejectedCount ?? 0); 
      }
    } catch (error) {
      if (error.response) {
        console.error("Error Status:", error.response.status);
        console.error("Error Data:", error.response.data);
      } else {
        console.error("Error fetching category:", error);
      }
    }
  };

  useEffect(() => {
    getLocationFilter();
    getDepartmentFilter();
  }, []);

  // useEffect(() => {
  //   getListData(activeButton); // This will now always get the latest value
  // }, [activeButton]);

  const getLocationFilter = async () => {
    try {
      const response = await getLocationFilterApi();
      if (response.success === true) {
        setLocations(response.suggestionlist);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const getDepartmentFilter = async () => {
    try {
      const response = await getDepartmentFilterApi();
      if (response.success === true) {
        setDepartments(response.suggestionlist);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const onCourierStatusSuccess=async (response)=>{
    setShowUpdateCourierStatusModal(false);
    setSnackbarMessage(response.message);
    setSnackbarStatus(response.status);
    handleSnackbarShow();
    getListData(term)
  }
 useEffect(() => {
      if(selectedStatus!==""){
      setChecklistFailedAdminModal(true)
      }
      },[selectedStatus]);

          const onApprovedCheckList=async ()=>{
            setChecklistFailedAdminModal(false);
           checkListFailsUpdate('approve');
          }
          const onRejectedCheckList=()=>{
            setChecklistFailedAdminModal(false);
            checkListFailsUpdate('reject');
          }
          const checkListFailsUpdate = async (status) => {   
            try {
              const response = await checkListFailsUpdateApi(courierDetails.id,status,'courier');
              if (response.data.success === true) {
                setSnackbarMessage(response.data.message);
                setSnackbarStatus(response.data.success);
                handleSnackbarShow();
                getListData(term)
              }
          return response.data;
            } catch (err) {
              console.error("Error fetching category:", err);
            } finally {
            }
          };
          const listCount = (menu) => {
            switch (menu) {             
              case "Approved":
                return approvedCount;
              case "Checklist Failed":
                return checkListCount; 
              case "Rejected":
                return rejectedCount;
              case "Completed":
                return completedCount;
              default:
                return  0;
            }
        
          }


            const isFieldEnabled=(field)=> {
                return listingColumns.filter((option) =>
                  ((activeButton==='queue' || activeButton==='approved' || activeButton==='checklist-failed' || activeButton==='schedule' || activeButton==='rejected')  && (option.value!=='in_time' && option.value!=='out_time' && option.value!=='responsible_pername')) ||
                ((activeButton==='checklist-failed')  && (option.value!=='in_time' && option.value!=='out_time')) ||
                ((activeButton==='gatein')  && (option.value!=='out_time' && option.value!=='responsible_pername')) || ((activeButton==='completed')  && option.value!=='responsible_pername')
                  ).some(item => item.status===true && item.label === field);
              }
              const dropdownRef = useRef(null);
              const toggleColumn = (key) => {
               
                const tempColumn=[...listingColumns];
                const index = tempColumn.findIndex(column => column.value === key);
                if(index>-1){
                tempColumn[index].status=!tempColumn[index].status;
                }
                setListingColumns(tempColumn)
              };
              useEffect(() => {
                const handleClickOutside = (event) => {
                  if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                    setShowCustomColumPopup(false);
                  }
                };
                document.addEventListener('mousedown', handleClickOutside);
                return () => document.removeEventListener('mousedown', handleClickOutside);
              }, []);



  return (
    <div style={{ display: "flex", flexDirection: "column" ,fontFamily: 'Epilogue'}}>
       {showUpdateCourierStatusModal && <CourierReceivedModal courierId={courierDetails.id} onSuccess={onCourierStatusSuccess} onCancel={() =>{setShowUpdateCourierStatusModal(false);}} />}
            {showChecklistFailedAdminModal && <CheckListFailedAdminModal moduleId={courierDetails.id} moduleName={"Courier"} checkList={courierDetails.checklist??[]} visitorName={courierDetails.person_name} organization={courierDetails.company_name} visitorPicture={courierDetails.profilephoto??''} isSaveEnable={false}  isApprovedEnable={selectedStatus==='Approve'?true:false} onApproved={onApprovedCheckList} isRejectedEnable={selectedStatus==='Reject'?true:false} onRejected={onRejectedCheckList}  onCancel={() =>{setChecklistFailedAdminModal(false);setSelectedStatus('');}} />}
      <div>
      <TopBar currentName="courier" />
      </div>
      <div style={{ backgroundColor: "#FFFFFF" }}>
        {isVisible && (
          <div
            className="container-auto mt-3 ms-4 me-4 mb-3"
            style={{ fontFamily: "Epilogue" }}
          >
            <div className="row align-items-center gx-2">
              {" "}
              {/* Reduced horizontal gap */}
              {/* Summary Heading */}
              <div className="col-md-auto d-flex align-items-center">
                <span className="fw-bold me-2 text-center text-md-start">
                  Summary of your
                  <br /> overall entries
                </span>
                <span className="text-muted">
                  <img src={arrow} alt="Arrow" />
                </span>
              </div>
              {/* Gate In Card */}
              <div className="col-sm-3" style={{ width: "20%" }}>
                <div
                  className="card border-1 rounded-3"
                  style={{ borderColor: "#E5E5E5", width: "95%" }}
                >
                  <div className="card-body d-flex align-items-center p-2">
                    <img src={gtin} alt="Gate In" />
                    <div className="ms-2">
                      <h6 className="mb-0 fw-bold">{data.gateInCount}</h6>
                      <small className="text-muted">Gate in</small>
                    </div>
                    <span
                      className="badge ms-auto mb-3 ms-2"
                      style={{ background: "#f7f8f9", color: "#2C8C53" }}
                    >
                      {data.gateInPercentage}%
                    </span>
                  </div>
                </div>
              </div>
              {/* Gate Out Card */}
              <div className="col-sm-3 " style={{ width: "20%" }}>
                <div
                  className="card border-1 rounded-3 "
                  style={{ borderColor: "#E5E5E5", width: "95%" }}
                >
                  <div className="card-body d-flex align-items-center p-2">
                    <img src={gtot} alt="Gate Out" />
                    <div className="ms-2">
                      <h6 className="mb-0 fw-bold">{data.gateOutCount}</h6>
                      <small className="text-muted">Gate out</small>
                    </div>
                    <span
                      className="badge ms-auto mb-3 ms-2"
                      style={{ background: "#f7f8f9", color: "#2C8C53" }}
                    >
                      {data.gateOutPercentage}%
                    </span>
                  </div>
                </div>
              </div>
              {/* Scheduled Card */}
              <div className="col-sm-3" style={{ width: "20%" }}>
                <div
                  className="card border-1 rounded-3 "
                  style={{ borderColor: "#E5E5E5", width: "95%" }}
                >
                  <div className="card-body d-flex align-items-center p-2">
                    <img src={scheule} alt="Scheduled" />
                    <div className="ms-2">
                      <h6 className="mb-0 fw-bold">{data.scheduleCount}</h6>
                      <small className="text-muted">Scheduled</small>
                    </div>
                    <span
                      className="badge ms-auto mb-3 ms-2"
                      style={{ background: "#f7f8f9", color: "#2C8C53" }}
                    >
                      {data.schedulePercentage}%
                    </span>
                  </div>
                </div>
              </div>
              {/* Hide Button */}
              <div className="col-auto ms-auto mb-4">
                <button
                  className="btn btn-light rounded d-flex align-items-center justify-content-center"
                  type="button"
                  onClick={() => setIsVisible(false)}
                  style={{
                    width: "65px",
                    background: "#e2f4e9",
                    color: "#252525",
                    fontSize: "12.5px",
                    height: "24px",
                    gap: "5px",
                    borderRadius: "8px",
                    padding: "4px 12px",
                  }}
                >
                  Hide
                  <img
                    src={vectorup}
                    alt="Arrow Up"
                    style={{ width: "8px", height: "8px" }}
                  />
                </button>
              </div>
            </div>
          </div>
        )}

        <div
          className="mt-4 ms-4 me-4"
          style={{
            top: "89px",
            left: "24px",
            gap: "24px",
            fontFamily: "Epilogue",
            fontWeight: "500",
            color: "#172B4D",
          }}
        >
          <div>
            <div
              className="d-flex justify-content-between align-items-center mb-3"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div style={{ fontSize: 20, fontWeight: "700" }}>
                Courier list
              </div>
              {!isVisible && (
                <div
                  style={{
                    background: "#e2f4e9",
                    color: "#252525",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "4px 12px",
                    borderRadius: "8px",
                  }}
                >
                  <button
                    className="btn"
                    style={{
                      fontFamily: "Epilogue, sans-serif",
                      fontWeight: "500",
                      fontSize: "12.5px",
                      lineHeight: "100%",
                      letterSpacing: "0%",
                      textTransform: "capitalize",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: "0",
                    }}
                    onClick={() => setIsVisible(true)}
                  >
                    Show analytics{" "}
                    <img
                      src={vector}
                      style={{ width: "8px", height: "8px", marginLeft: "6px" }}
                    />{" "}
                  </button>
                </div>
              )}
            </div>

            {/* Buttons Section */}
             <Row>
                                     <Col className="mt-2" sm={12} lg={8}>
                                       <div style={{ height: '40px', }}>
                           <div className="d-flex  hide-scroll" style={{ width: '100%' }}>
                  {buttons.map(({ label, value }) => (
                    <button
                      key={value}
                      className="btn rounded-3 me-2"
                      onClick={() => handleButtonClick(value)}
                      style={{
                        backgroundColor:
                          activeButton === value ? "#D6ffe6" : "#f8f8f8",
                        border:
                          activeButton === value ? "1px solid #2c8c53" : "none",
                          padding: "10px 16px",
                          borderRadius: "12px",
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontWeight: "600",
                          fontSize: "13px",
                          color: "#172B4D",
                          whiteSpace: "nowrap",
                      }}
                    >
                      {label} {'('+listCount(label)+')'} 
                    </button>
                  ))}
                </div>
              </div>
               </Col>
              <Col className="mt-2" sm={12} lg={4}>
              <div style={{ position: "relative" }}>
              <div className="hide-scroll"
                style={{
                  height:'50px',
                  /* display: "flex",
                  justifyContent: isFilterOpen ? "space-between" : "flex-end",
                  alignItems: "center", */
                }}
              >
                {/* Buttons container */}
                <div style={{ display: "flex", alignItems: "center",width: "max-content", }}>
                  {/* Search input/button */}
                  {showInput ? (
                    <div
                      className="input-group rounded-pill me-2"
                      style={{ width: "250px" }}
                    >
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search visitors..."
                        style={{
                          boxShadow: "none",
                          outline: "none",
                          border: "1px solid #dcdfe4",
                        }}
                        onChange={(e) => {
                          const value = e.target.value;
                          setTerm(value); 
                        }}
                        
                        value={term}
                      />
                      <button
                        className="btn btn-outline-secondary"
                        style={{ borderColor: "#dcdfe4" }}
                        onClick={() => setShowInput(false)}
                      >
                        <img src={search} alt="Search Icon" />
                      </button>
                    </div>
                  ) : (
                    <button
                      className="btn rounded-3 me-2"
                      style={{ borderColor: "#dcdfe4" }}
                      onClick={() => setShowInput(true)}
                    >
                      <img src={search} alt="Search Icon" />
                    </button>
                  )}

                  {/* Other buttons */}
                  <button
                    className="btn rounded-3 me-2"
                    style={{ borderColor: "#dcdfe4" }}
                  >
                    <img src={df} />
                    <select
                      style={{ outline: "none", border: "none" }}
                      onChange={(e) => {
                        const [field, order] = e.target.value.split(" ");
                        setSortByField(field);
                        setSortBy(order);
                      }}
                    >
                      <option value="">Default (data created)</option>
                      <option value="gate_visitors.visitor_name asc">
                        Name (Asc)
                      </option>
                      <option value="gate_visitors.visitor_name desc">
                        Name (Dsc)
                      </option>
                      <option value="gate_visitors.created_at asc">
                        Date (Oldest)
                      </option>
                      <option value="gate_visitors.created_at desc">
                        Date (Newest)
                      </option>
                    </select>
                  </button>

                  <button onClick={()=>{setShowCustomColumPopup(true)}}
                    className="btn rounded-3 me-2"
                    style={{ borderColor: "#dcdfe4" }}
                  >
                    <img src={cus} /> Customize Table
                  </button>
                  <button
                    className="btn rounded-3"
                    style={{ borderColor: "#dcdfe4" }}
                    data-bs-toggle="offcanvas"
                    data-bs-target="#filterPanel"
                  >
                    <img src={filt} alt="Filter Icon" /> Filter
                  </button>
                </div>

                {/* Filter panel */}
                <div
                  className="offcanvas offcanvas-end"
                  // tabIndex="-1"
                  id="filterPanel"
                  aria-labelledby="filterPanelLabel"
                  style={{
                    background: "#F8F9F9",
                    width: "300px",
                    zIndex: 1050,
                  }}
                  data-bs-backdrop="false"
                  data-bs-keyboard="false"
                >
                  <div className="offcanvas-header">
                    <h5 id="filterPanelLabel">Filters</h5>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="offcanvas"
                      aria-label="Close"
                    ></button>
                  </div>

                  <div className="offcanvas-body">
                    <form>
                      <div className="mb-3">
                        <label
                          className="form-label"
                          style={{ color: "#172B4D" }}
                        >
                          Location
                        </label>
                        <select
                          className="form-select"
                          style={{ color: "#8790A1" }}
                          value={location}
                          onChange={(e) => setLocation(e.target.value)}
                        >
                          <option value="">-- Select --</option>
                          {locations.map((location) => (
                            <option key={location.value} value={location.value}>
                              {location.label}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="mb-3">
                        <label
                          className="form-label"
                          style={{ color: "#172B4D" }}
                        >
                          Department
                        </label>
                        <select
                          className="form-select"
                          style={{ color: "#8790A1" }}
                          value={department}
                          onChange={(e) => setDepartment(e.target.value)}
                        >
                          <option value="">-- Select --</option>
                          {departments.map((dept) => (
                            <option key={dept.value} value={dept.value}>
                              {dept.label}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="mb-3">
                        <label
                          className="form-label"
                          style={{ color: "#172B4D" }}
                        >
                          Date Range
                        </label>
                        <DatePicker
                          selectsRange={true}
                          startDate={from_date}
                          endDate={to_date}
                          onChange={(update) => setDateRange(update)}
                          className="form-control"
                          placeholderText="Select"
                        />
                      </div>

                      <div className="row mb-3">
                        {/* Gate In Date Range Picker */}
                        <div className="col-6">
                          <label
                            className="form-label"
                            style={{ color: "#172B4D" }}
                          >
                            Gate In
                          </label>
                          <DatePicker
                            selectsRange={true}
                            startDate={from_gate_in}
                            endDate={to_gate_in}
                            onChange={(update) => setGateInRange(update)}
                            className="form-control"
                            placeholderText="Select"
                          />
                        </div>

                        {/* Gate Out Date Range Picker */}
                        <div className="col-6">
                          <label
                            className="form-label"
                            style={{ color: "#172B4D" }}
                          >
                            Gate Out
                          </label>
                          <DatePicker
                            selectsRange={true}
                            startDate={from_gate_out}
                            endDate={to_gate_out}
                            onChange={(update) => setGateOutRange(update)}
                            className="form-control"
                            placeholderText="Select"
                          />
                        </div>
                      </div>
                    </form>

                    <div className="row p-3 flex justify-content-center mt-5">
                      <button
                        className="col-5 btn rounded-pill me-2"
                        style={{
                          background: "#FFFFFF",
                          borderColor: "#E5E5E5",
                        }}
                        onClick={handleReset}
                      >
                        Reset
                      </button>
                      <button
                        className="col-5 btn rounded-pill btn-success"
                        onClick={getFilterListData}
                      >
                        Apply
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              {showCustomColumPopup && (
        <div
          ref={dropdownRef}
          style={{ position: "absolute",
            top: "40px",
            right: "-10%",
            transform: "translateX(-50%)",
            backgroundColor: "#ffffff",
            color: "#1E1E1E",
            padding: "16px",
            borderRadius: "16px",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            zIndex: 1000,alignItems:'end', }}
         
        >
          <div className="font-semibold mb-2" style={{fontSize:'18px'}}>Select Columns</div>
          {listingColumns.filter((option) =>
      ((activeButton==='queue' || activeButton==='approved' || activeButton==='checklist-failed' || activeButton==='schedule' || activeButton==='rejected')  && (option.value!=='in_time' && option.value!=='out_time' && option.value!=='responsible_pername')) ||
    ((activeButton==='checklist-failed')  && (option.value!=='in_time' && option.value!=='out_time')) ||
    ((activeButton==='gatein')  && (option.value!=='out_time' && option.value!=='responsible_pername')) || ((activeButton==='completed')  && option.value!=='responsible_pername')
      ).map((col, index) => (
            <div key={col.value} className="mb-1">
              <label>
                <input
                  type="checkbox"
                  checked={col.status}
                  onChange={() => toggleColumn(col.value)}
                />
                <span className="ms-2" style={{fontSize:'16px'}}>{col.label}</span>
              </label>
            </div>
          ))}
        </div>
      )}
                </div>
           </Col>
           </Row>
          </div>

          {/* Visitors Table */}
          <div className="table-responsive">
            <table className="table table-hover border table-bordered align-middle">
              <thead>
                <tr style={{ fontSize: "13px", textTransform: "capitalize" }}>
                {isFieldEnabled("S.No") && (<th style={{textAlign:'center', color: "#174b4d", background: "#f8f9f9" }}>
                     S.No
                  </th>)}
                  {isFieldEnabled("Person Name") && (<th style={{ color: "#174b4d", background: "#f8f9f9" }}>
                    <img src={frame} className="mb-1" /> Person Name
                  </th>)}
                  {isFieldEnabled("Gate") && (<th style={{ color: "#174b4d", background: "#f8f9f9" }}>
                                      <img src={gate} className="mb-1" /> Gate
                                    </th>)}
                  {isFieldEnabled("In time") && (<th style={{ color: "#174b4d", background: "#f8f9f9" }}>
                    <img src={clock} className="mb-1" /> In time
                  </th>)}
                  {isFieldEnabled("Received time") && ( <th style={{ color: "#174b4d", background: "#f8f9f9" }}>
                    <img src={clock} className="mb-1" /> Received time
                  </th>)}
                  {isFieldEnabled("Company name") && (<th style={{ color: "#174b4d", background: "#f8f9f9" }}>
                    <img src={org} className="mb-1" /> Company Name
                  </th>)}
                  
                  {isFieldEnabled("Company contact number") && (<th style={{ color: "#174b4d", background: "#f8f9f9" }}>
                    <img src={pov} className="mb-1" /> Company Number
                  </th>)}
                  {isFieldEnabled("Receiver name") && (<th
                    style={{
                      color: "#174b4d",
                      background: "#f8f9f9",
                       
                    }}
                  >
                    <img src={meet} className="mb-1" /> Whom Received
                  </th>)}
                </tr>
              </thead>
              <tbody>
                {couriers.map((courier, index) => (
                  <tr
                    key={index}
                    onMouseEnter={() => setHoveredRow(index)}
                    onMouseLeave={() => setHoveredRow(null)}
                    style={{
                      fontSize: "13px",
                      textTransform: "capitalize",
                      position: "relative",
                    }}
                    onClick={()=>{ navigate("/courier-view", { state: {id: courier.id, } });}}
                  >
                    {isFieldEnabled("S.No") && (<td className="text-center align-middle">
                      {((itemOffset) * itemsPerPage)+(index+1)}
                    </td>)}
                    {isFieldEnabled("Person Name") && (<td style={{ color: "#172b4d" }}>{courier.person_name}</td>)}
                    {isFieldEnabled("Gate") && (<td style={{ color: "#172b4d" }}>{courier.gate}</td>)}
                    {isFieldEnabled("In time") && (<td style={{ color: "#172b4d" }}>{courier.in_time}</td>)}
                    {isFieldEnabled("Received time") && (<td style={{ color: "#172b4d" }}>{courier.received_time}</td>)}
                    {isFieldEnabled("Company name") && (<td style={{ color: "#172b4d" }}>{courier.company_name}</td>)}
                   
                    {isFieldEnabled("Company contact number") && (<td style={{ color: "#172b4d" }}>
                      {courier.company_contactnumber}
                    </td>)}

                    {/* Minimized Meeting Person Column */}
                    {isFieldEnabled("Receiver name") && (<td
                      style={{
                        color: "#172b4d",
                        position: "relative",
                        width: "120px",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      <span
                        className="btn rounded-pill"
                        style={{
                          backgroundColor: "#f1f2f4",
                          color: "black",
                          padding: "2px 8px",
                          fontSize: "12px",
                          height: "24px",
                          lineHeight: "1.2",
                          position: "relative",
                          zIndex: 2, // Keeps text above row
                        }}
                      >
                        {courier.first_name}
                      </span>

                      {/* Buttons Appear OVER the Row on Hover */}
                     
                    </td>)}
                    {hoveredRow === index &&  (
                                      <td className="row-widget" colSpan="1">
                                       <div
                                                style={{
                                                  position: "absolute",
                                                  top: "0",
                                                  left: "0",
                                                  width: "100%",
                                                  height: "100%",
                                                  background: "transparent",
                                                  display: "flex",
                                                  justifyContent: "end",
                                                  alignItems: "center",
                                                  gap: "5px",
                                                  zIndex: 3,
                                                }}
                                              >
                                               
                                                 {courier.check_list_status !=='reject' && courier.check_list_status!=='pending'  && courier.received_time===null && (
                                                  <button className="btn rounded-3 btn-success btn-sm"
                                                  onClick={(e)=>{ e.stopPropagation(); setCourierDetails(courier);setShowUpdateCourierStatusModal(true)}}>
                                                    Update status
                                                  </button>)} 
                                               
                                                 
                                      {loginID!==null && courier.responsible_person === (loginID.toString()) && courier.check_list_status==='pending'  && (
                                  <div className="style-justify-center">
                                     
                                      <div className="checklist-reject-btn style-justify-center"
                                        onClick={(e)=>{ e.stopPropagation();setCourierDetails(courier);setSelectedStatus('Reject')}}>
                                        Reject
                                      </div>
                                      <div className="approve-btn style-justify-center"
                                       onClick={(e)=>{ e.stopPropagation();setCourierDetails(courier);setSelectedStatus('Approve')}}>
                                        Approve
                                      </div>
                                      </div>)}
                      
                                                  
                                                 
                                                   
                                                 
                                                 
                                              </div>
                                      </td>
                                    )}  
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          

          <Row>
            <Col>
              <div className="d-flex align-items-center justify-content-start mx-3">
                <span
                  style={{
                    fontFamily: "Epilogue",
                    fontSize: "13px",
                    fontWeight: "500",
                    color: "#212129",
                  }}
                >
                  Records per page :
                </span>
                <select
                  className="select3"
                  id="perpage"
                  value={itemsPerPage}
                  onChange={(event) => {
                    setItemsPerPage(event.target.value);
                  }}
                  style={{
                    cursor: "pointer",
                    fontFamily: "Epilogue",
                    fontSize: "14px",
                    fontWeight: "500",
                    lineHeight: "18.9px",
                    color: "#212129",
                    width: "56px",
                    height: "24px",
                    borderRadius: "10px",
                    border: "0.7px solid #E5E5E5",
                    padding: "0 4px",
                    backgroundColor: "#FFFFFF",
                  }}
                >
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="30">30</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </div>
            </Col>
            <Col>
              <div className="d-flex justify-content-end">
                <ReactPaginate
                  previousLabel={
                    <img src={lar} className="ar3" alt="previous" />
                  }
                  nextLabel={<img src={rar} className="ar3" alt="next" />}
                  breakLabel={"..."}
                  pageCount={pageCount+1}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={3}
                  onPageChange={handlePageClick}
                  containerClassName={"pagination"}
                  activeClassName={"active"}
                />
              </div>
            </Col>
          </Row>
        </div>
      </div>
       <ToastContainer position="top-end">
                          <Toast
                            className="d-inline-block m-1"
                            bg={snackbarStatus === true ? "success" : "danger"}
                            show={showSnackbar}
                            onClose={handleSnackbarClose}
                            delay={3000}
                            autohide
                          >
                            <Toast.Body style={{ color: "#ffffff" }}>
                              {snackbarMessage}
                            </Toast.Body>
                          </Toast>
                        </ToastContainer>
    </div>
  );
};

export default CourierList;






































































































































// import React, { useState } from "react";
// import One from "../../assets/svg/One.svg";
// import Two from "../../assets/svg/Two.svg";
// import Three from "../../assets/svg/Three.svg";
// import four from "../../assets/svg/Four.svg";
// import five from "../../assets/svg/Five.svg";
// import six from "../../assets/svg/Six.svg";
// import sev from "../../assets/svg/Sev.svg";
// import Driver from "../../assets/svg/Driver.svg";
// import Check from "../../assets/svg/Check.svg";
// import In from "../../assets/svg/In.svg";
// import Out from "../../assets/svg/Out.svg";
// import Company from "../../assets/svg/Company.svg";
// import Phone from "../../assets/svg/Phone.svg";
// import Ph from "../../assets/svg/ph2.svg";
// import Meeting from "../../assets/svg/Meeting.svg";
// import Big from "../../assets/svg/Big.svg";
// import Door from "../../assets/svg/Door.svg";
// import Doorout from "../../assets/svg/Doorout.svg";
// import Time from "../../assets/svg/Time.svg";
// import TopBar from "../topbar/TopBar";

// const Courierlist = () => {
//   const [isSearchOpen, setIsSearchOpen] = useState(false);

//   const toggleSearch = () => {
//     setIsSearchOpen((prev) => !prev);
//   };
//   const [isVisible, setIsVisible] = useState(false);

//   const toggleVisibility = () => {
//     setIsVisible(!isVisible);
//   };
//   const [isOpen, setIsOpen] = useState(false);

//   const togglePanel = () => {
//     setIsOpen(!isOpen);
//   };
//   const [activeButton, setActiveButton] = useState(null);

//   const handleClick = (button) => {
//     setActiveButton(button);
//   };

//   const getButtonStyle = (button) => ({
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     gap: "8px",
//     fontFamily: "Epilogue",
//     fontWeight: "500",
//     borderRadius: "12px",
//     padding: "10px 16px",
//     backgroundColor: activeButton === button ? "#D6FFE6" : "#F8F8F8",
//     border: "none",
//     cursor: "pointer",
//   });

//   const data = [
//     {
//       driverName: "Sathish Kumar",
//       gateIn: "23-03-2023 05:48 PM",
//       gateOut: "23-03-2023 05:48 PM",
//       vehicleNumber: "TN 45 AV 5686",
//       proof: "Aadhaar Card",
//       purpose: "Business Meeting",
//       meetingPerson: "Sasikumar - CEO",
//     },
//     {
//       driverName: "John Doe",
//       gateIn: "24-03-2023 09:00 AM",
//       gateOut: "24-03-2023 09:00 AM",
//       vehicleNumber: "TN 45 AV 5686",
//       proof: "Passport",
//       purpose: "Project Kick-Off",
//       meetingPerson: "Emily - Project Manager",
//     },
//     {
//       driverName: "Alice Smith",
//       gateIn: "24-03-2023 11:30 AM",
//       gateOut: "24-03-2023 11:30 AM",
//       vehicleNumber: "TN 45 AV 5686",
//       proof: "Driver’s License",
//       purpose: "Design Presentation",
//       meetingPerson: "Michael - Lead Designer",
//     },
//     {
//       driverName: "Alice Smith",
//       gateIn: "24-03-2023 11:30 AM",
//       gateOut: "24-03-2023 11:30 AM",
//       vehicleNumber: "TN 45 AV 5686",
//       proof: "Driver’s License",
//       purpose: "Design Presentation",
//       meetingPerson: "Michael - Lead Designer",
//     },
//     {
//       driverName: "Alice Smith",
//       gateIn: "24-03-2023 11:30 AM",
//       gateOut: "24-03-2023 11:30 AM",
//       vehicleNumber: "TN 45 AV 5686",
//       proof: "Driver’s License",
//       purpose: "Design Presentation",
//       meetingPerson: "Michael - Lead Designer",
//     },
//     {
//       driverName: "Alice Smith",
//       gateIn: "24-03-2023 11:30 AM",
//       gateOut: "24-03-2023 11:30 AM",
//       vehicleNumber: "TN 45 AV 5686",
//       proof: "Driver’s License",
//       purpose: "Design Presentation",
//       meetingPerson: "Michael - Lead Designer",
//     },
//     {
//       driverName: "Alice Smith",
//       gateIn: "24-03-2023 11:30 AM",
//       gateOut: "24-03-2023 11:30 AM",
//       vehicleNumber: "TN 45 AV 5686",
//       proof: "Driver’s License",
//       purpose: "Design Presentation",
//       meetingPerson: "Michael - Lead Designer",
//     },
//     {
//       driverName: "Sathish Kumar",
//       gateIn: "23-03-2023 05:48 PM",
//       gateOut: "23-03-2023 05:48 PM",
//       vehicleNumber: "TN 45 AV 5686",
//       proof: "Aadhaar Card",
//       purpose: "Business Meeting",
//       meetingPerson: "Sasikumar - CEO",
//     },
//     {
//       driverName: "Sathish Kumar",
//       gateIn: "23-03-2023 05:48 PM",
//       gateOut: "23-03-2023 05:48 PM",
//       vehicleNumber: "TN 45 AV 5686",
//       proof: "Aadhaar Card",
//       purpose: "Business Meeting",
//       meetingPerson: "Sasikumar - CEO",
//     },
//     {
//       driverName: "Sathish Kumar",
//       gateIn: "23-03-2023 05:48 PM",
//       gateOut: "23-03-2023 05:48 PM",
//       vehicleNumber: "TN 45 AV 5686",
//       proof: "Aadhaar Card",
//       purpose: "Business Meeting",
//       meetingPerson: "Sasikumar - CEO",
//     },
//     {
//       driverName: "John Doe",
//       gateIn: "24-03-2023 09:00 AM",
//       gateOut: "24-03-2023 09:00 AM",
//       vehicleNumber: "TN 45 AV 5686",
//       proof: "Passport",
//       purpose: "Project Kick-Off",
//       meetingPerson: "Emily - Project Manager",
//     },
//     {
//       driverName: "John Doe",
//       gateIn: "24-03-2023 09:00 AM",
//       gateOut: "24-03-2023 09:00 AM",
//       vehicleNumber: "TN 45 AV 5686",
//       proof: "Passport",
//       purpose: "Project Kick-Off",
//       meetingPerson: "Emily - Project Manager",
//     },
//     {
//       driverName: "John Doe",
//       gateIn: "24-03-2023 09:00 AM",
//       gateOut: "24-03-2023 09:00 AM",
//       vehicleNumber: "TN 45 AV 5686",
//       proof: "Passport",
//       purpose: "Project Kick-Off",
//       meetingPerson: "Emily - Project Manager",
//     },
//   ];
//   return (
//     <div style={{ display: "flex", flexDirection: "column" }}>


//       <div>
//         <TopBar />
//       </div>


//       <div style={{ fontFamily: "Epilogue" }}>
//         <div style={{ padding: "20px" }}>
//           <div
//             style={{
//               display: "flex",
//               justifyContent: "space-between",
//             }}
//           >
//             <div>
//               {/* Toggle Button */}
//               <div>
//                 <div
//                   onClick={toggleVisibility}
//                   style={{
//                     fontFamily: "Epilogue",
//                     display: "inline-flex",
//                     alignItems: "center",
//                     justifyContent: "end",
//                     marginLeft: "1060px",
//                     backgroundColor: "#E6F4EA",
//                     borderRadius: "8px",
//                     padding: "4px 6px",
//                     whiteSpace: "nowrap", // Ensure the text doesn't break
//                     cursor: "pointer",
//                     border: "none",
//                   }}
//                 >
//                   <span
//                     style={{
//                       fontSize: "12px",
//                       color: "#212121",
//                       fontWeight: "500",
//                       whiteSpace: "nowrap", // Keep text in one line
//                     }}
//                   >
//                     {isVisible ? "Hide" : "Show analytics"}
//                   </span>
//                   <span
//                     style={{
//                       fontSize: "16px",
//                       color: "#212121",
//                       marginLeft: "8px",
//                       transform: isVisible ? "rotate(180deg)" : "rotate(0deg)",
//                       transition: "transform 0.3s ease",
//                     }}
//                   >
//                     ▾
//                   </span>
//                 </div>
//               </div>

//               {/* Collapsible Content */}
//               {isVisible && (
//                 <div
//                   style={{
//                     fontFamily: "Epilogue",
//                     marginBottom: "25px",
//                   }}
//                 >
//                   <div
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "20px",
//                     }}
//                   >
//                     {/* Summary Heading */}
//                     <div
//                       style={{
//                         display: "flex",
//                         alignItems: "center",
//                         gap: "10px",
//                       }}
//                     >
//                       <span style={{ color: "#172B4D" }}>
//                         Summary of your <br /> overall entries
//                       </span>
//                       <img src={Big} alt="Arrow" />
//                     </div>

//                     {/* Cards Section */}
//                     <div style={{ display: "flex", gap: "20px" }}>
//                       {[
//                         {
//                           icon: Door,
//                           count: 347,
//                           label: "Gate in",
//                           color: "#FFFFFF",
//                         },
//                         {
//                           icon: Doorout,
//                           count: 450,
//                           label: "Gate out",
//                           color: "#FFFFFF",
//                         },
//                         {
//                           icon: Time,
//                           count: 64,
//                           label: "Scheduled",
//                           color: "#FFFFFF",
//                         },
//                       ].map((card, index) => (
//                         <div
//                           key={index}
//                           style={{
//                             width: "200px",
//                             padding: "12px",
//                             borderRadius: "12px",
//                             backgroundColor: card.color,
//                             border: "1px solid #E5E5E5",
//                             display: "flex",
//                             alignItems: "center",
//                             justifyContent: "space-between",
//                           }}
//                         >
//                           <div
//                             style={{
//                               display: "flex",
//                               alignItems: "center",
//                               gap: "10px",
//                             }}
//                           >
//                             <img src={card.icon} alt={card.label} />
//                             <div>
//                               <h6 style={{ margin: 0, fontWeight: "bold" }}>
//                                 {card.count}
//                               </h6>
//                               <small style={{ color: "#6B7280" }}>
//                                 {card.label}
//                               </small>
//                             </div>
//                           </div>
//                           <span
//                             style={{
//                               backgroundColor: "#f7f8f9",
//                               color: "#2C8C53",
//                               padding: "4px 8px",
//                               borderRadius: "12px",
//                               fontSize: "12px",
//                               fontWeight: "500",
//                             }}
//                           >
//                             +23%
//                           </span>
//                         </div>
//                       ))}
//                     </div>
//                   </div>
//                 </div>
//               )}
//             </div>
//           </div>
//           <div
//             style={{
//               fontSize: "20px",
//               color: "#1D2B4F",
//               marginLeft: "20px",
//               width: "500px",
//               height: "20px",
//               fontWeight: "700",
//             }}
//           >
//             Courier list
//           </div>
//           <div
//             style={{
//               display: "flex",
//               justifyContent: "space-between",
//             }}
//           >
//             <div
//               style={{
//                 marginLeft: "15px",
//                 display: "flex",
//                 gap: "10px",
//                 marginBottom: "20px",
//                 marginTop: "20px",
//               }}
//             >
//               {/* Queue Button */}
//               <button
//                 style={getButtonStyle("Queue")}
//                 onClick={() => handleClick("Queue")}
//               >
//                 <img
//                   src={One}
//                   alt="Queue Icon"
//                   style={{ width: "18px", height: "18px" }}
//                 />
//                 Queue
//               </button>

//               {/* Approved Button */}
//               <button
//                 style={getButtonStyle("Approved")}
//                 onClick={() => handleClick("Approved")}
//               >
//                 <img
//                   src={Two}
//                   alt="Approved Icon"
//                   style={{ width: "18px", height: "18px" }}
//                 />
//                 Approved
//               </button>

//               {/* Checklist Failed Button */}
//               <button
//                 style={{
//                   ...getButtonStyle("Checklist Failed"),
//                   width: "156px",
//                   whiteSpace: "nowrap",
//                 }}
//                 onClick={() => handleClick("Checklist Failed")}
//               >
//                 <img
//                   src={Three}
//                   alt="Checklist Failed Icon"
//                   style={{ width: "18px", height: "18px" }}
//                 />
//                 Checklist Failed
//               </button>
//             </div>

//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "flex-end",
//                 gap: "10px",
//                 marginLeft: "100px",
//                 alignItems: "center",
//                 transition: "margin-right 0.3s ease",
//                 marginRight: isOpen ? "360px" : "0",
//               }}
//             >
//               {/* Circle Button */}
//               <div style={{ display: "flex", alignItems: "center" }}>
//                 {/* Search Bar (Left Side) */}
//                 {isSearchOpen && (
//                   <input
//                     type="text"
//                     placeholder="Search Couriers"
//                     style={{
//                       width: "200px",
//                       height: "40px",
//                       borderRadius: "8px",
//                       border: "1px solid #ccc",
//                       fontSize: "14px",
//                       marginRight: "10px",
//                       transition: "width 0.3s ease",
//                     }}
//                   />
//                 )}

//                 {/* Search Icon Button */}
//                 <button
//                   onClick={toggleSearch}
//                   style={{
//                     width: "36px",
//                     height: "36px",
//                     border: "0.6px solid #ccc",
//                     borderRadius: "50%",
//                     backgroundColor: "white",
//                     cursor: "pointer",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                   }}
//                 >
//                   <img
//                     src={four}
//                     alt="Queue Icon"
//                     style={{ width: "22px", height: "22px" }}
//                   />
//                 </button>
//               </div>
//               {/* Default Button */}
//               <button
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   gap: "5px",
//                   padding: "8px 15px",
//                   borderRadius: "10px",
//                   border: "1px solid #ccc",
//                   backgroundColor: "white",
//                   fontFamily: "Epilogue",
//                   fontWeight: "500",
//                   cursor: "pointer",
//                 }}
//               >
//                 <img
//                   src={five}
//                   alt="Queue Icon"
//                   style={{ width: "18px", height: "18px" }}
//                 />
//                 Default (Date Created)
//               </button>

//               {/* Customize Table Button */}
//               <button
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   gap: "5px",
//                   padding: "8px 15px",
//                   borderRadius: "10px",
//                   fontFamily: "Epilogue",
//                   fontWeight: "500",
//                   border: "1px solid #ccc",
//                   backgroundColor: "white",
//                   cursor: "pointer",
//                 }}
//               >
//                 <img
//                   src={six}
//                   alt="Queue Icon"
//                   style={{ width: "18px", height: "18px" }}
//                 />
//                 Customize Table
//               </button>

//               <button
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   gap: "5px",
//                   padding: "8px 15px",
//                   borderRadius: "10px",
//                   border: "1px solid #dcdfe4",
//                   backgroundColor: "white",
//                   cursor: "pointer",
//                 }}
//                 onClick={togglePanel}
//               >
//                 <img
//                   src={sev}
//                   alt="Filter Icon"
//                   style={{ width: "18px", height: "18px" }}
//                 />
//                 {isOpen ? "Close Filter" : "Filter"}
//               </button>

//               {/* Sliding Panel */}
//               <div
//                 style={{
//                   position: "fixed",
//                   top: "0",
//                   right: isOpen ? "0" : "-300px",
//                   width: "250px",
//                   height: "100vh",
//                   backgroundColor: "#F8F9F9",
//                   boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
//                   transition: "right 0.3s ease",
//                   zIndex: 1000,
//                   padding: "20px",
//                 }}
//               >
//                 {/* Header */}
//                 <div
//                   style={{
//                     display: "flex",
//                     justifyContent: "space-between",
//                     marginBottom: "20px",
//                   }}
//                 >
//                   <h2
//                     style={{ margin: 0, fontSize: "20px", fontWeight: "600" }}
//                   >
//                     Filters
//                   </h2>
//                   <button
//                     onClick={togglePanel}
//                     style={{
//                       background: "none",
//                       border: "none",
//                       cursor: "pointer",
//                       fontSize: "18px",
//                     }}
//                   >
//                     ✖
//                   </button>
//                 </div>

//                 {/* Form Fields */}
//                 {["Location", "Department"].map((label) => (
//                   <div key={label} style={{ marginBottom: "16px" }}>
//                     <label
//                       style={{
//                         display: "block",
//                         marginBottom: "8px",
//                         color: "#6B7280",
//                         fontSize: "14px",
//                       }}
//                     >
//                       {label}
//                     </label>
//                     <select
//                       style={{
//                         width: "100%",
//                         padding: "10px",
//                         borderRadius: "8px",
//                         border: "1px solid #ccc",
//                         backgroundColor: "white",
//                         fontSize: "14px",
//                         color: "#6B7280",
//                       }}
//                     >
//                       <option>Select</option>
//                     </select>
//                   </div>
//                 ))}

//                 {/* Date Range */}
//                 <div style={{ marginBottom: "16px" }}>
//                   <label
//                     style={{
//                       display: "block",
//                       marginBottom: "8px",
//                       color: "#6B7280",
//                       fontSize: "14px",
//                     }}
//                   >
//                     Date range
//                   </label>
//                   <button
//                     style={{
//                       width: "100%",
//                       padding: "10px",
//                       borderRadius: "8px",
//                       border: "1px solid #E5E5E5",
//                       backgroundColor: "#ffffff",
//                       color: "#2c8c53",
//                       fontSize: "14px",
//                       cursor: "pointer",
//                     }}
//                   >
//                     Select
//                   </button>
//                 </div>

//                 {/* Gate In & Out */}
//                 <div
//                   style={{
//                     display: "flex",
//                     justifyContent: "space-between",
//                     marginBottom: "16px",
//                   }}
//                 >
//                   {["Gate in", "Gate out"].map((label) => (
//                     <div key={label} style={{ width: "48%" }}>
//                       <label
//                         style={{
//                           display: "block",
//                           marginBottom: "8px",
//                           color: "#6B7280",
//                           fontSize: "14px",
//                         }}
//                       >
//                         {label}
//                       </label>
//                       <button
//                         style={{
//                           width: "100%",
//                           padding: "10px",
//                           borderRadius: "8px",
//                           border: "1px solid #E5E5E5",
//                           backgroundColor: "#ffffff",
//                           color: "#2c8c53",
//                           fontSize: "14px",
//                           cursor: "pointer",
//                         }}
//                       >
//                         Select
//                       </button>
//                     </div>
//                   ))}
//                 </div>

//                 {/* Status */}
//                 <div style={{ marginBottom: "16px" }}>
//                   <label
//                     style={{
//                       display: "block",
//                       marginBottom: "8px",
//                       color: "#6B7280",
//                       fontSize: "14px",
//                     }}
//                   >
//                     Status
//                   </label>
//                   <select
//                     style={{
//                       width: "100%",
//                       padding: "10px",
//                       borderRadius: "8px",
//                       border: "1px solid #ccc",
//                       backgroundColor: "white",
//                       fontSize: "14px",
//                       color: "#6B7280",
//                     }}
//                   >
//                     <option>Select</option>
//                   </select>
//                 </div>

//                 {/* Buttons */}
//                 <div
//                   style={{
//                     display: "flex",
//                     justifyContent: "space-between",
//                     marginTop: "20px",
//                   }}
//                 >
//                   <button
//                     style={{
//                       width: "116px",
//                       height: "44px",
//                       borderRadius: "45px",
//                       backgroundColor: "#FFFFFF",
//                       border: "1px solid #E5E5E5",
//                       color: "#212121",
//                       cursor: "pointer",
//                       padding: "10px 32px",
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       gap: "11px",
//                     }}
//                   >
//                     Reset
//                   </button>
//                   <button
//                     style={{
//                       width: "116px",
//                       height: "44px",
//                       borderRadius: "45px",
//                       backgroundColor: "#2c8c53",
//                       color: "#ffffff",
//                       border: "none",
//                       cursor: "pointer",
//                       padding: "10px 32px",
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       gap: "11px",
//                     }}
//                   >
//                     Apply
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <div
//             style={{
//               padding: "20px",
//               marginTop: "-15px",
//             }}
//           >
//             <table
//               style={{
//                 width: "100%",
//                 borderCollapse: "collapse",
//                 fontSize: "13px",
//                 textAlign: "left",
//                 color: "#172B4D",
//               }}
//             >
//               <thead>
//                 <tr
//                   style={{
//                     backgroundColor: "#E5E5E5",
//                     borderBottom: "1px solid #ddd",
//                   }}
//                 >
//                   {[
//                     { icon: Check, label: "", style: { marginLeft: "6px" } },
//                     { icon: Driver, label: "Driver Name" },
//                     { icon: In, label: "Gate In" },
//                     { icon: Out, label: "Gate Out" },
//                     {
//                       icon: Company,
//                       label: "Vehicle Number",
//                     },
//                     { icon: Phone, label: "Proof" },
//                     {
//                       icon: Ph,
//                       label: "Purpose Of Visit",
//                     },
//                     {
//                       icon: Meeting,
//                       label: "Meeting Person",
//                     },
//                   ].map((item, index) => (
//                     <th
//                       key={index}
//                       style={{
//                         padding: "8px",
//                         color: "#172B4D",
//                         backgroundColor: "#F1F2F4",
//                         textAlign: "left",
//                         borderRight: index === 7 ? "none" : "1px solid #ddd",
//                       }}
//                     >
//                       {item.label === "" ? (
//                         <span style={item.style}>
//                           <img
//                             src={item.icon}
//                             alt="Check"
//                             style={{ width: "16px", height: "16px" }}
//                           />
//                         </span>
//                       ) : (
//                         <span
//                           style={{
//                             display: "flex",
//                             alignItems: "center",
//                             gap: "8px",
//                           }}
//                         >
//                           <img
//                             src={item.icon}
//                             alt={item.label}
//                             style={{ width: "16px", height: "16px" }}
//                           />
//                           {item.label}
//                         </span>
//                       )}
//                     </th>
//                   ))}
//                 </tr>
//               </thead>

//               <tbody>
//                 {data.map((row, index) => (
//                   <tr
//                     key={index}
//                     style={{
//                       borderBottom: "1px solid #ddd",
//                       transition: "background-color 0.3s ease",
//                     }}
//                     onMouseEnter={(e) =>
//                       (e.currentTarget.style.backgroundColor = "#F1F2F4")
//                     }
//                     onMouseLeave={(e) =>
//                       (e.currentTarget.style.backgroundColor = "white")
//                     }
//                   >
//                     <td
//                       style={{
//                         padding: "10px",
//                         borderRight: "1px solid  #F1F2F4",
//                       }}
//                     >
//                       <input type="checkbox" />
//                     </td>
//                     <td
//                       style={{
//                         padding: "10px",
//                         borderRight: "1px solid #F1F2F4",
//                       }}
//                     >
//                       {row.driverName}
//                     </td>
//                     <td
//                       style={{
//                         padding: "10px",
//                         borderRight: "1px solid #F1F2F4",
//                       }}
//                     >
//                       {row.gateIn}
//                     </td>
//                     <td
//                       style={{
//                         padding: "10px",
//                         borderRight: "1px solid #F1F2F4",
//                       }}
//                     >
//                       {row.gateOut}
//                     </td>
//                     <td
//                       style={{
//                         padding: "10px",
//                         borderRight: "1px solid #F1F2F4",
//                       }}
//                     >
//                       {row.vehicleNumber}
//                     </td>
//                     <td
//                       style={{
//                         padding: "10px",
//                         borderRight: "1px solid #F1F2F4",
//                       }}
//                     >
//                       {row.proof}
//                     </td>
//                     <td
//                       style={{
//                         padding: "10px",
//                         borderRight: "1px solid #F1F2F4",
//                       }}
//                     >
//                       {row.purpose}
//                     </td>
//                     <td
//                       style={{
//                         marginTop: "10px",
//                         marginLeft: "10px",
//                         backgroundColor: "#F1F2F4",
//                         borderRadius: "8px",
//                         display: "inline-flex",
//                         justifyContent: "center",
//                         alignItems: "center",
//                         textAlign: "center",
//                         fontSize: "12px",
//                         whiteSpace: "nowrap",
//                         padding: "4px 8px",
//                         height: "15px",
//                       }}
//                     >
//                       {row.meetingPerson}
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 fontFamily: "Epilogue",
//                 fontWeight: "500",
//                 marginTop: "10px",
//                 alignItems: "center",
//               }}
//             >
//               <span style={{ fontSize: "14px" }}>
//                 Records per page:
//                 <select
//                   style={{
//                     marginLeft: "5px",
//                     padding: "5px",
//                     borderRadius: "5px",
//                     border: "1px solid #ddd",
//                   }}
//                 >
//                   <option>10</option>
//                   <option>20</option>
//                   <option>50</option>
//                 </select>
//               </span>
//             </div>
//           </div>
//           <div
//             style={{
//               display: "flex",
//               justifyContent: "flex-end",
//               transform: "translateY(-40px)",
//             }}
//           >
//             <nav className="me-4">
//               <ul
//                 className="pagination"
//                 style={{
//                   display: "flex",
//                   listStyle: "none",
//                   padding: 0,
//                   margin: 0,
//                 }}
//               >
//                 <li className="page-item disabled">
//                   <button
//                     className="me-2"
//                     style={{
//                       width: "25px",
//                       height: "25px",
//                       borderRadius: "50%",
//                       border: "none",
//                       outline: "none",
//                       background: "none",
//                       cursor: "pointer",
//                     }}
//                   >
//                     &lt;
//                   </button>
//                 </li>

//                 {[1, 2, 3, 4, 5].map((num, index) => (
//                   <li
//                     className={`page-item ${num === 1 ? "active" : ""}`}
//                     key={index}
//                   >
//                     <button
//                       className="me-2"
//                       style={{
//                         width: "25px",
//                         height: "25px",
//                         borderRadius: "50%",
//                         background: num === 1 ? "#2c8c53" : "none",
//                         color: num === 1 ? "#ffffff" : "#172b4d",
//                         fontFamily: "Epilogue",
//                         border: "none",
//                         outline: "none",
//                         cursor: "pointer",
//                       }}
//                     >
//                       {num}
//                     </button>
//                   </li>
//                 ))}

//                 <li className="page-item">
//                   <button
//                     className="me-2"
//                     style={{
//                       width: "25px",
//                       height: "25px",
//                       borderRadius: "50%",
//                       border: "none",
//                       outline: "none",
//                       background: "none",
//                       cursor: "default",
//                     }}
//                   >
//                     ...
//                   </button>
//                 </li>

//                 <li className="page-item">
//                   <button
//                     className="me-2"
//                     style={{
//                       width: "25px",
//                       height: "25px",
//                       borderRadius: "50%",
//                       border: "none",
//                       outline: "none",
//                       background: "none",
//                       cursor: "pointer",
//                     }}
//                   >
//                     &gt;
//                   </button>
//                 </li>
//               </ul>
//             </nav>
//           </div>
//         </div>
//       </div>

      
//     </div>
//   );
// };

// export default Courierlist;
